import { render } from "./StreamsContent.vue?vue&type=template&id=9223c140"
import script from "./StreamsContent.vue?vue&type=script&lang=js"
export * from "./StreamsContent.vue?vue&type=script&lang=js"

import "./StreamsContent.vue?vue&type=style&index=0&id=9223c140&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__